import { NavigateFunction } from 'react-router-dom';
import { toast } from 'react-toastify';

import { appendSearch } from '@utils/appendSearch';
import { movePath, planMovesPath, productRootPath } from '@features/products/productRoutes';

// Every path carries the embed's query string (`search`, the current location's), which holds
// its whole configuration: the hash session, the rooftop, `readOnly`, the branding.

export const goToRoute = (route: string | null, navigate: NavigateFunction, search: string) => {
  if (route) navigate(appendSearch(route, search));
  else toast.error(`No route was specified!`, { toastId: 'navigation-missing-target' });
};

export const goToPreviousPage = (navigate: NavigateFunction) => {
  navigate(-1);
};

export const goToNextPage = (navigate: NavigateFunction) => {
  navigate(1);
};

export const goToMovesIndex = (navigate: NavigateFunction, search: string) => {
  navigate(appendSearch(productRootPath('moves'), search));
};

export const goToLanesIndex = (navigate: NavigateFunction, search: string) => {
  navigate(appendSearch(`/lanes`, search));
};

export const goToLocationsIndex = (navigate: NavigateFunction, search: string) => {
  navigate(appendSearch(`/locations`, search));
};

export const goToLocationDetails = (navigate: NavigateFunction, locationId: number, search: string) => {
  navigate(appendSearch(`/locations/${locationId}`, search));
};

export const goToMovePlanner = (navigate: NavigateFunction, search: string) => {
  navigate(appendSearch(planMovesPath(), search));
};

export const goToMoveDetails = (moveId: string | null, edit = false, navigate: NavigateFunction, search: string) => {
  if (moveId && edit) {
    navigate(appendSearch(movePath(moveId), search), { state: { editMode: true } });
  } else if (moveId) {
    navigate(appendSearch(movePath(moveId), search));
  } else {
    toast.error(`No move ID was specified!`, { toastId: 'navigation-missing-target' });
  }
};

export const goToInvoice = (
  invoiceId: string | null,
  customerId: string | null,
  foldId: string | null,
  navigate: NavigateFunction,
  search: string
) => {
  if (invoiceId) localStorage.setItem('invoice-id', invoiceId);
  if (customerId) localStorage.setItem('invoice-customer-id', customerId);
  if (foldId) localStorage.setItem('invoice-fold-id', foldId);
  navigate(appendSearch(`/invoices`, search));
};

export const goToUserDetails = (userId: string | null, navigate: NavigateFunction, search: string) => {
  if (userId) navigate(appendSearch(`/users/${userId}`, search));
  else toast.error(`No user ID was specified!`, { toastId: 'navigation-missing-target' });
};
